/*
 view_creditcard

 creditcardmock = {
 "utimestamp": 1458224412998,
 "am": "50",
 "bid": null,
 "paymentMethodId": 1,
 "cid": null,
 "cn": "4444333322221111",
 "co": "bimal james",
 "vm": "06",
 "vy": "2016",
 "cc": "737"
 },

 */
import actions from '../../common/lib/utils/actions.js';
import constants from '../../common/lib/utils/constants.js';
import core from '../../common/lib/core.js';
import validateCreditcard from '../lib/validate-creditcard.js';
import viewDateCreator from '../lib/view-creditcard-date.js';
import viewCreditcardlastCreator from '../lib/view-creditcardlast.js';
import viewTextkeys from '../../commonview/lib/view-textkeys.js';

const create = core.create; // creates basic elements not inserted into the dom
const creditCardMaxLength = 16;
const regexCC = '[0-9]*';
const regexCVC = '[0-3]*';
const classnameShow = 'u-show';
const classnameHide = 'u-hide';
const classnameDisable = 'custom-select—disabled';
const notvalidClass = 'input-wrap__error';

let cardnumberDefaultPlaceholder;
let dateIsResetForNewCard;
let textkeysObj = {};
let viewCreditcardlast;
let viewDate;

let elements = {
	/* see 'assembleElements' below for more details of the elements object content */
	assembled: false,
	optionscardref: {},
	optionsmonthref: {},
	optionsyearref: {},
	wraplastused: null,
	wrap: null
};

let userInput = {
	allvalid: false,
	amount: null, // am
	cardid: null,
	cardnumber: null, // cn
	cvc: null, // cc
	year: null, // vy
	month: null // vm
};

function toSubmitStructure(uInput) {
	/* This is the structure required by the depositmethod. To not hardcode keys in earlier steps the values are parsed here. */
	/* amount is set in /view-paymentform */
	/* id set if earlier used cards are available */
	return {
		am: uInput.amount,
		cid: uInput.cardid,
		cc: uInput.cvc,
		co: 'not needed',
		cn: uInput.cardnumber,
		utimestamp: new Date().getTime(),
		vy: uInput.year,
		vm: uInput.month,
		paymentMethodId: 1 // this id is the same as in the ajax-response from 'getDepositPaymentMethods' and 'deposit-form-template-conf.js'
	};
}

function createSelectOrAddCardTitle(txt) {
	const elm = create({
		type: 'legend',
		class: 'legend'
	});
	if (txt) {
		elm.innerHTML = txt;
	}
	return elm;
}

function createCardnumberTitle(txt) {
	const elm = create({
		type: 'legend',
		class: 'legend'
	});
	if (txt) {
		elm.innerHTML = txt;
	}
	return elm;
}

function createYearMonthCvcTitle(txt) {
	const elm = create({
		type: 'legend',
		class: 'legend u-truncate'
	});
	if (txt) {
		elm.innerHTML = txt;
	}
	return elm;
}

function createInputcvc() {
	return create({
		type: 'input',
		class: 'js-payment__input-cvc-creditcard payment__input-cvc-creditcard input-wrap__input',
		name: 'cc',
		'input-type': 'text',
		max: 999,
		min: 0,
		placeholder: 'CVC',
		pattern: regexCVC,
		autocomplete: 'off'
	});
}

function createInputCardId() {
	return create({
		type: 'input',
		name: 'cardid',
		'input-type': 'hidden',
		max: 9999,
		min: 1
	});
}

function createInputcardnumber() {
	return create({
		type: 'input',
		class: 'js-payment__input-cn-creditcard payment__input-cn-creditcard input-wrap__input',
		name: 'cn',
		'input-type': 'text',
		maxlength: creditCardMaxLength,
		pattern: regexCC,
		placeholder: cardnumberDefaultPlaceholder
	});
}

function createFeedback(txt) {
	const elm = create({
		type: 'small',
		class: 'input-wrap__error-display payment__feedback grid-u-sm-1 u-hide'
	});
	if (txt) {
		elm.innerHTML = txt;
	}
	return elm;
}

function createFieldsetWrapLastused() {
	/* this is used in init outside of createElements also TODO: replace with one  */
	return create({
		type: 'fieldset',
		class: 'js-payments__fieldset-wrap-lastused payments__fieldset-wrap-lastused custom-select u-relative u-mb2'
	});
}

function createElements() {
	elements.wraplastused = (elements.wraplastused || createFieldsetWrapLastused());
	elements.wrapnewcard = (elements.wrapnewcard || create('div', 'js-payments__fieldset-wrap-newcard payments__fieldset-wrap-newcard input-wrap u-relative'));
	elements.cardnumberTitle = (elements.cardnumberTitle || createCardnumberTitle(textkeysObj['deposit-inputfieldtitle-cardnumber']));
	elements.yearTitle = (elements.yearTitle || createYearMonthCvcTitle(textkeysObj['deposit-inputfieldtitle-year']));
	elements.monthTitle = (elements.monthTitle || createYearMonthCvcTitle(textkeysObj['deposit-inputfieldtitle-month']));
	elements.cvcTitle = (elements.cvcTitle || createYearMonthCvcTitle(textkeysObj['deposit-inputfieldtitle-cvc']));
	elements.fieldsetwrapmm = (elements.fieldsetwrapmm || create('fieldset', 'payments__fieldset-wrap-mm custom-select u-relative'));
	elements.fieldsetwrapyy = (elements.fieldsetwrapyy || create('fieldset', 'payments__fieldset-wrap-yy custom-select u-relative'));
	elements.gridwrapyy = (elements.gridwrapyy || create('div', 'payments__grid-wrap-yy grid-u-sm-1-3 u-pr1 u-pl1'));
	elements.gridwrapcvc = (elements.gridwrapcvc || create('div', 'payments__grid-wrap-cvc grid-u-sm-1-3 u-pl1'));
	elements.gridwrapmmyycvc = (elements.gridwrapmmyycvc || create('div', 'payments__grid-wrap-mm-cvc grid-r u-mt2'));
	elements.gridwrapmm = (elements.gridwrapmm || create('div', 'payments__grid-wrap-mm grid-u-sm-1-3 u-pr1'));
	elements.inputcardnumber = (elements.inputcardnumber || createInputcardnumber());
	elements.cardnumberfeedback = (elements.cardnumberfeedback || createFeedback(textkeysObj['cardnumber-feedback']));
	elements.cvcfeedback = (elements.cvcfeedback || createFeedback(textkeysObj['cvc-feedback']));
	elements.yyfeedback = (elements.yyfeedback || createFeedback(textkeysObj['year-feedback']));
	elements.datefeedback = (elements.datefeedback || createFeedback(textkeysObj['the-expiry-date-has-passed']));
	elements.mmfeedback = (elements.mmfeedback || createFeedback(textkeysObj['month-feedback']));
	elements.inputcvc = (elements.inputcvc || createInputcvc());
	elements.inputcardid = (elements.inputcardid || createInputCardId());
	elements.labelcardnumber = (elements.labelcardnumber || create('label', 'payment__label-cn-creditcard'));
	elements.labelcvc = (elements.labelcvc || create('label', 'payment__label-cvc-creditcard'));
}

function assembleElements() {
	createElements();
	if (!elements.assembled) {
		elements.fieldsetwrapmm.appendChild(elements.monthTitle);
		elements.gridwrapmm.appendChild(elements.fieldsetwrapmm);
		elements.gridwrapmm.appendChild(elements.datefeedback);
		elements.gridwrapmm.appendChild(elements.mmfeedback);
		elements.fieldsetwrapyy.appendChild(elements.yearTitle);
		elements.gridwrapyy.appendChild(elements.fieldsetwrapyy);
		elements.gridwrapyy.appendChild(elements.yyfeedback);
		elements.labelcvc.appendChild(elements.inputcvc);
		elements.labelcvc.appendChild(elements.cvcfeedback);
		elements.gridwrapcvc.appendChild(elements.cvcTitle);
		elements.gridwrapcvc.appendChild(elements.labelcvc);
		elements.gridwrapmmyycvc.appendChild(elements.gridwrapmm);
		elements.gridwrapmmyycvc.appendChild(elements.gridwrapyy);
		elements.gridwrapmmyycvc.appendChild(elements.gridwrapcvc);
		elements.labelcardnumber.appendChild(elements.cardnumberTitle);
		elements.labelcardnumber.appendChild(elements.inputcardnumber);
		elements.labelcardnumber.appendChild(elements.cardnumberfeedback);
		/* insert selectbox with options */
		// only show the wrapper when it is updated
		core.addClass(elements.wraplastused, classnameShow);
		// elements.wrapnewcard.appendChild(elements.detailsTitle);
		elements.wrapnewcard.appendChild(elements.labelcardnumber);
		elements.wrapnewcard.appendChild(elements.gridwrapmmyycvc);
		/* inputCard is a hidden inputfield */
		elements.wrapnewcard.appendChild(elements.inputcardid);
		/* insert the created nodes into the provided wrapper */
		if (elements.before) {
			elements.wrap.insertBefore(elements.wraplastused, elements.before);
			elements.wrap.insertBefore(elements.wrapnewcard, elements.before);
		} else {
			elements.wrap.appendChild(elements.wraplastused);
			elements.wrap.appendChild(elements.wrapnewcard);
		}
		elements.assembled = true;
	}
}

function deleteAllElements() {
	/* The object-property must either contain an element or an array with elements */
	/* The wrapper is not deleted. */
	if (elements.assembled) {
		core.deleteElementsInObjectExcept(elements, ['wrap', 'before', 'inputamountwrap', 'inputamount', 'amountfeedback', 'textkeys'], '/view-creditcard:385');
		elements.assembled = false;
	}
}

function hideNewcardinputExceptCvc() {
	core.addClass(elements.fieldsetwrapmm, classnameDisable);
	core.addClass(elements.fieldsetwrapyy, classnameDisable);
	core.addClass(elements.labelcardnumber, classnameDisable);
}

function showNewcardinputAndCvc() {
	core.removeClass(elements.fieldsetwrapmm, classnameDisable);
	core.removeClass(elements.fieldsetwrapyy, classnameDisable);
	core.removeClass(elements.labelcardnumber, classnameDisable);
}

function hideLastCardWrap() {
	core.removeClass(elements.wraplastused, classnameShow);
	core.addClass(elements.wraplastused, classnameHide);
}

function showLastCardWrap() {
	core.removeClass(elements.wraplastused, classnameHide);
	core.addClass(elements.wraplastused, classnameShow);
}

function show(elm) {
	core.removeClass(elm, classnameHide);
	core.addClass(elm, classnameShow);
}

function hide(elm) {
	core.removeClass(elm, classnameShow);
	core.addClass(elm, classnameHide);
}

function hideElm(elm, yesHideIt) {
	if (yesHideIt) {
		hide(elm);
	} else {
		show(elm);
	}
}

function markValid(element, valid) {
	if (valid) {
		core.removeClass(element, notvalidClass);
	} else {
		core.addClass(element, notvalidClass);
	}
}

function feedbackToDate(p, elms) {
	/* when adding a new card, the datefield should not indicate 'not valid' on
	the other field (MM or YYYY) before the other field is selected. But if
	the form is submitted the 'not valid' indication shall be there. */
	const monthHasError = p.monthHasError;
	const dateHasError = p.dateHasError;
	const yearHasError = p.yearHasError;
	if (monthHasError || dateHasError) {
		markValid(elms.fieldsetwrapmm, false);
	} else {
		markValid(elms.fieldsetwrapmm, true);
	}
	if (monthHasError) {
		show(elms.mmfeedback);
	} else {
		hide(elms.mmfeedback);
	}
	if (yearHasError) {
		markValid(elms.fieldsetwrapyy, false);
		show(elms.yyfeedback);
	} else {
		markValid(elms.fieldsetwrapyy, true);
		hide(elms.yyfeedback);
	}
	if (dateHasError) {
		show(elms.datefeedback);
	} else {
		hide(elms.datefeedback);
	}
}

function feedbackToCardnumber(cardNumber, cardId) {
	/* One of these parameters could be empty or null depending on if it's a new card or an existent one
	for adding new card the cardNumber shouldn't be empty or null and cardId could be
	for existent card the cardNumber will be null and cardId will not. */
	if (cardNumber || cardId) {
		markValid(elements.inputcardnumber, true);
		hide(elements.cardnumberfeedback);
	} else {
		markValid(elements.inputcardnumber, false);
		hideElm(elements.cardnumberfeedback, false);
	}
}

function feedbackToCvc(inputIsValid) {
	markValid(elements.inputcvc, inputIsValid);
	hideElm(elements.cvcfeedback, inputIsValid);
}

function markValidAll(uInput) {
	/* depending on validation the inputfields are marked
    with specific classname and messages with feedback are shown
	*/
	const validDate = viewDate.getValues();
	const monthHasError = Boolean(validDate.feedbackMonth);
	const yearHasError = Boolean(validDate.feedbackYear);
	const dateHasError = Boolean(validDate.feedbackDate);
	if (uInput) {
		feedbackToDate({
			monthHasError,
			yearHasError,
			dateHasError
		}, elements);
		feedbackToCardnumber(uInput.cardnumber, uInput.cardid);
		// feedbackToAmount(uInput.amount);
		feedbackToCvc(uInput.cvc);
	}
}

function markValidReset() {
	feedbackToDate({
		monthHasError: false,
		yearHasError: false,
		dateHasError: false
	}, elements);
	feedbackToCardnumber(true);
	feedbackToCvc(true);
}

function validCardId() {
	const theInput = elements.inputcardid.value || null;
	return (validateCreditcard.cardid(theInput) ? theInput : null);
}

function validCardnumber() {
	/* The cardnumber input field has to be of type 'number' to display the numeric keyboard. A preselected cardnumber is presented as a mix of 'x' and digits. */
	/* This is presented through the 'placeholder' attribute. Thus the cardnumber has to be validated together with the 'card id' */
	/* If a cardnumber is present, it must be valid. If a cardnumber is not present, a valid 'card id' must exist. */
	const theInput = core.trailspace(elements.inputcardnumber.value || null);
	return (validateCreditcard.number(theInput) ? theInput : null);
}

function validCvc() {
	const theInput = core.trailspace(elements.inputcvc.value || null);
	return (validateCreditcard.cvc(theInput) ? theInput : null);
}

function setInputValues(p) {
	/* if adding a new card, the default placeholder shall remain.
	otherwise if using an old card, the default placeholder is
	replaced by '**********1234' */
	const cn = ((p && p.cn) || null);
	const vm = ((p && p.vm) || constants.DEFAULT);
	const vy = ((p && p.vy) || constants.DEFAULT);
	const cardid = ((p && p.cardid) || null); // 'cardid');
	const placeholder = ((p && p.cn) || cardnumberDefaultPlaceholder);
	elements.inputcardnumber.placeholder = placeholder;
	/* If a previously used cardnumber is selected from selectlist, this number is presented */
	/* from the 'placeholder' because of it is a input of type 'number' and won't otherwise not display. */
	elements.inputcardnumber.value = cn;
	elements.inputcvc.value = null; /* this value shall always be reset to nothing*/
	elements.inputcardid.value = cardid;
	viewDate.update({
		view_creditcard: {
			month: vm,
			year: vy
		}
	});
}

function getValidUserInput() {
	/* parse the valid input to the userInput */
	const validatedMMYY = viewDate.getValues();
	const cardnumber = validCardnumber();
	const cardid = validCardId();
	const cvc = validCvc();
	const month = validatedMMYY.month;
	const year = validatedMMYY.year;
	/* 1.If a cardnumber is input, it must be valid.
    2.If no cardnumber is specified, the card id must be valid. */
	const allvalid = Boolean((cardnumber || cardid) && cvc && month && year);
	return {
		allvalid,
		cardid,
		cardnumber,
		cvc,
		month,
		year
	};
}

function clickHandler(e) {
	/* clicked add creditcard */
	const cb = function click(p) {
		p.e.stopPropagation();
		p.e.preventDefault();
		setInputValues(); /* to empty */
		showNewcardinputAndCvc();
	};
	/* If the last argument is set to 'true', the handler function runs the callback if the .fkn_filter element or any of its children (#content_A,#content_B,#inner_content) is clicked*/
	core.handle(e, '.js-event-filter__addcreditcard', cb, false);
}

function changeHandler(e) {
	const cb = function change(p) {
		p.e.preventDefault();
		p.e.stopPropagation();
		if (p.elm === elements.inputcardnumber) {
			/* if cardnumber has input then it must be valid.
            if cardnumber has no input then there must be a valid card-id instead.*/
			feedbackToCardnumber(validCardnumber());
			actions.viewCreditCardNew(elements.inputcardnumber.value);
		} else if (p.elm === elements.inputcvc) {
			feedbackToCvc(validCvc());
		}
	};
	/* If the last argument is set to 'true', the handler function runs the callback if the .fkn_filter element or any of its children (#content_A,#content_B,#inner_content) is clicked*/
	core.handle(e, '.js-payment__input-cvc-creditcard', cb, true);
	core.handle(e, '.js-payment__input-cn-creditcard', cb, true);
}

function onKeyPressHandler(e) {
	const cb = function click(p) {
		p.e.stopPropagation();
		// only numbers charCode
		if (!(p.e.charCode >= 48 && p.e.charCode <= 57)) {
			p.e.preventDefault();
		}
	};
	const cbCvc = function click(p) {
		p.e.stopPropagation();
		// only numbers charCode and max length 3
		if (!(p.e.charCode >= 48 && p.e.charCode <= 57) || p.e.target.value.length >= 3) {
			p.e.preventDefault();
		}
	};
	core.handle(e, '.js-payment__input-cn-creditcard', cb, true);
	core.handle(e, '.js-payment__input-cvc-creditcard', cbCvc, true);
}

function addListeners() {
	core.addListener(elements.wrap, 'change', changeHandler);
	core.addListener(elements.wrap, 'click', clickHandler);
	core.addListener(elements.wrap, 'keypress', onKeyPressHandler);
}

function removeListeners() {
	if (elements && elements.wrap) {
		core.removeListener(elements.wrap, 'change', changeHandler);
		core.removeListener(elements.wrap, 'click', clickHandler);
		elements.wrap.removeEventListener('keypress', onKeyPressHandler);
	}
}

export default {
	create() {
		// TODO: this method will replace the 'init'. See 'view-methods.js' for an example. The 'create' api method must exist to be a
		// valid paymentmodule. See 'deposit-form-template-conf.js'
		return;
	},
	init(p) {
		// refresh the dom if re-init
		elements = core.deleteElementsInObjectExcept(elements, ['wrap', 'before', 'inputamountwrap', 'inputamount', 'amountfeedback', 'textkeys'], '/view-creditcard:385');
		elements.wrap = core.getElementIfValid(p, 'wrap', 'view-creditcard:init:592');
		/* if a 'before' element is provided the content will be inserted before this*/
		/*
        The inputfield for amount is created by view_paymentform, and is persistant for all paymentmethods.
        The validation may vary, and the formatting into the submitstructure varies between different methods.
        The inputelement is therefore a read-only property outisde view_paymentform.
        */
		textkeysObj = viewTextkeys.depositflow();
		cardnumberDefaultPlaceholder = textkeysObj['enter-cardnumber-please'];

		/* if the user has no previously used cards, the validation shall not trigger too early */
		dateIsResetForNewCard = true;

		function selectLastUsedCb() {
			/* another card is selected and the validation shall reset any previously added feedback */
			const creditCardIdValue = viewCreditcardlast.getValues();
			if (creditCardIdValue.add) {
				setInputValues();
				dateIsResetForNewCard = true; // to prevent the validation on date to trigger to early
			} else {
				setInputValues(creditCardIdValue);
				/* revalidate*/
				userInput = getValidUserInput();
				hideNewcardinputExceptCvc();
			}
			markValidReset();
		}

		function viewDateCb(validation) {
			const monthHasError = Boolean(validation.feedbackMonth);
			const yearHasError = Boolean(validation.feedbackYear);
			const dateHasError = Boolean(validation.feedbackDate);
			if (dateIsResetForNewCard) {
				dateIsResetForNewCard = false; // the first selection is done
			} else {
				feedbackToDate({
					monthHasError,
					yearHasError,
					dateHasError
				}, elements);
			}
		}

		viewCreditcardlast = viewCreditcardlastCreator.create({
			callbackonmainevent: selectLastUsedCb
		});
		viewDate = viewDateCreator.create({
			callbackonmainevent: viewDateCb
		});

		// the wraplastused-element has to be created, which is also done in 'assembleElements'
		elements.wraplastused = (elements.wraplastused || createFieldsetWrapLastused());
		elements.selectoraddcardTitle = (elements.selectoraddcardTitle || createSelectOrAddCardTitle(textkeysObj['deposit-inputfieldtitle-selectoraddcard']));
		elements.wraplastused.appendChild(elements.selectoraddcardTitle);
		elements.wraplastused.appendChild(viewCreditcardlast.wrap);
		addListeners();
	},
	update(state) {
		/* delete previously created paymentforms */
		/* sync which type of states that shall be updated from view.js */
		/* the module connected to the view is seen in the key of the state object. 'state.moduleName' */
		const lastMethodExist = Boolean((state && state.fetch_methoddetails) && (Array.isArray(state.fetch_methoddetails.accounts) && state.fetch_methoddetails.accounts.length > 0));
		const paymentmethodsExist = Boolean((state && state.paymentmethods) && (state.paymentmethods && state.paymentmethods.methods));
		const paymentmethodsByNameExist = Boolean(paymentmethodsExist && state.paymentmethods.methods.by_name);
		let card = null;
		let cn = null;
		let cardid = null;
		let vm = null;
		let vy = null;
		if (state && state.paymentmethods) {
			if (paymentmethodsByNameExist && !elements.assembled) {
				assembleElements();
				elements.fieldsetwrapmm.appendChild(viewDate.wrapMonth);
				elements.fieldsetwrapyy.appendChild(viewDate.wrapYear);
				userInput.allvalid = false;
			}
			hideLastCardWrap();
			showNewcardinputAndCvc();
		}
		if (state && state.submit_payment) {
			/* reset some of the values in the form */
			if (state.submit_payment.success || state.submit_payment.error) {
				/* if previously used creditcards exist, the list will be reset to 'add new' so
				that the user is forced to actively select an old one or type a new, and
				thereby refresh the input. */
				setInputValues();
				viewCreditcardlast.update(state);
			} else if (state.submit_payment.refreshinput) {
				card = ((state && state.submit_payment) && (state.submit_payment.currentcard && state.submit_payment.currentcard.card));
				cn = ((card && card.cn) || (state.submit_payment.cardnumber));
				cardid = (card && card.cid);
				vm = (card && card.vm);
				vy = (card && card.vy);
				setInputValues({
					cn,
					cardid,
					vm,
					vy
				});
			}
		}
		if (state && state.fetch_methoddetails) {
			/* if there are accounts saved then hide the new CC field. */
			if (lastMethodExist) {
				/* display selectionlist of accounts */
				hideNewcardinputExceptCvc();
				showLastCardWrap();
				viewCreditcardlast.update(state);
				/* update the fields for cardnumber, month, year */
				setInputValues(viewCreditcardlast.getValues());
			} else {
				// this condition will rarely be met
				hideLastCardWrap();
				showNewcardinputAndCvc();
			}
		}
	},
	close() {
		userInput.allvalid = false;
		if (viewCreditcardlast) {
			viewCreditcardlast.close();
		}
		if (viewDate) {
			viewDate.close();
		}
		removeListeners();
		deleteAllElements();
		return null;
	},
	evalInput() {
		let structure = null;
		userInput = getValidUserInput();
		markValidAll(userInput);
		if (userInput.allvalid) {
			structure = toSubmitStructure(userInput);
			actions.viewCreditcard({
				card: structure
			});
		}
		return structure;
	}
};



// WEBPACK FOOTER //
// ./mobile-core/src/payment/payment/lib/view-creditcard.js